<template>
  <div class="liu pos-manage">
    <mt-header fixed title="商户进件" class="title1">
      <mt-button slot="right" @click="onTopToListCick">进件记录</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 营业执照 -->
      <div class="big-item" @click="onShangHuCreateTypeClick">
        <div class="big-item-col img-col">
          <img class="img" src="../../assets/customer_first_menu_1.png" alt="" />
          <span class="title">营业执照</span>
        </div>
        <div class="big-item-col txt-col">
          <span>○ 身份证</span>
          <span>○ 营业执照</span>
          <span>○ 开户许可证(银行卡)</span>
        </div>
      </div>
      <!-- 小微商户 -->
      <div class="big-item" :class="{ 'opacity-5': !isInUserWhiteList }" style="background-color: #3782dc !important; margin-top: 0.75rem" @click="onXiaoWeiCreateTypeClick">
        <div class="big-item-col img-col">
          <img class="img" src="../../assets/customer_first_menu_2.png" alt="" />
          <span class="title">小微商户</span>
        </div>
        <div class="big-item-col txt-col">
          <span>○ 身份证</span>
          <span>○ 银行卡</span>
          <span>&nbsp;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_WELCOME_NAME, PUBLIC_TOKEN, PUBLIC_H5POSMANAGEMODULE_OFFICIAL_APPID */
/* exported PUBLIC_TOKEN */

import { GetAreaList, GetAreaListAsTree, GetBusinessTreeListAsSecondaryNew, QueryCustomerPermission, GetTemporaryTokenByWeChatId } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'H5PosManageIndex',
  data() {
    return {
      appid: PUBLIC_H5POSMANAGEMODULE_OFFICIAL_APPID,
      key: PUBLIC_WELCOME_NAME,
      businessArr: [],
      isInBlackList: false,
      isInUserWhiteList: false,
      isInAutoWhiteList: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 测试用TOKEN：PUBLIC_TOKEN = 'b5e881bbc5f44316980e2eb4f0d3a3e0';
      if (!PUBLIC_TOKEN) {
        // 测试用code：const code = '031Zw6100MJYBP1gxr200u6dFY1Zw61x';
        const code = this.getUrlKey('code');
        if (code) {
          const param = {
            jsCode: code,
            type: 1,
            key: this.key,
          };
          GetTemporaryTokenByWeChatId(param)
            .then(res => {
              SucceedHandle2(
                res.code,
                res.msg,
                () => {
                  PUBLIC_TOKEN = res.data.token;
                  this.initPageData();
                },
                (code, msg) => {
                  CusLoadingClose();
                  msg && CusToast(msg);
                }
              );
            })
            .catch(err => {
              CusLoadingClose();
              const msg = NotSucceedHandle(err.message);
              msg && CusToast(msg);
            });
        } else {
          // 传随机数为了让微信不缓存此页面
          this.getCodeApi(Math.floor(Math.random() * 900000 + 100000));
        }
      } else {
        this.initPageData();
      }
    });
  },
  computed: {
    customScrollHeight() {
      return `padding-top:3rem;height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 获取url中参数
    getUrlKey(paramName) {
      const obj = {};
      const arr = decodeURIComponent(location.search).slice(1).split('&');
      for (let i = 0, newArr = []; i < arr.length; i++) {
        newArr = arr[i].split('=');
        if (typeof obj[newArr[0]] === 'undefined') {
          obj[newArr[0]] = newArr[1];
        }
      }
      return obj[paramName] || '';
    },
    // 微信交互，获取code
    getCodeApi(state = '') {
      const appid = this.appid;
      const reUrl = encodeURIComponent(location.href);
      const scope = 'snsapi_base'; // 静默授权 用户无感知
      const url = ` https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${reUrl}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.replace(url);
    },
    initPageData() {
      CusLoadingOpen();
      this.queryCustomerPermission(() => {
        // 2022.6.17 取省/市/区内容的接口换成了一个
        this.getProvinceCityAreaList(0, 0, id => {
          this.getProvinceCityAreaList(1, id, id => {
            this.getProvinceCityAreaList(2, id, () => {
              // 2022.6.13 加入了行业列表的前端缓存
              // 2022.7.18 加入判断缓存数据是否格式正确，如果存在但是length为0，则认为是格式错误的数据，重新调用接口获取数据
              // 2022.7.19 加入了判断缓存是否超过24小时，超过24小时则重新调用接口获取数据
              const businessStorageStr = localStorage.getItem('pos_global_business_list') || '';
              const businessStorageArr = businessStorageStr ? JSON.parse(businessStorageStr) : [];
              if (businessStorageStr && businessStorageArr.length > 0) {
                if (Date.now() - businessStorageArr[businessStorageArr.length - 1].nowDate > 24 * 60 * 60 * 1000) {
                  this.getAllBusinessList(() => {
                    CusLoadingClose();
                    localStorage.setItem('pos_global_business_list', JSON.stringify(this.businessArr));
                  });
                } else {
                  CusLoadingClose();
                }
              } else {
                this.getAllBusinessList(() => {
                  CusLoadingClose();
                  localStorage.setItem('pos_global_business_list', JSON.stringify(this.businessArr));
                });
              }
            });
          });
        });
      });
    },
    // 通过接口返回省/市/区
    getAreaListAsTree(callback = null) {
      const that = this;
      GetAreaListAsTree()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              that.POS_MANAGE_MODULE.globalCompanyProvince = [];
              that.POS_MANAGE_MODULE.globalCompanyCity = [];
              that.POS_MANAGE_MODULE.globalCompanyArea = [];
              // res.data 返回了带有所有省/市/区内容的树状结构数据集
              // 循环遍历此数据集将省/市/区分别存储到三个数组类型的功能变量中
              res.data.forEach(oneItem => {
                // 省为树型结构中的一级节点，循环遍历后取出存入globalCompanyProvince数组中
                const obj1 = {
                  id: oneItem.id,
                  parent: oneItem.parent_id,
                  label: oneItem.area_name,
                  value: oneItem.area_code,
                };
                that.POS_MANAGE_MODULE.globalCompanyProvince.push(obj1);
                if (oneItem.treeList && oneItem.treeList.length > 0) {
                  oneItem.treeList.forEach(twoItem => {
                    // 市为树型结构中的二级节点，循环遍历后取出存入globalCompanyCity数组中
                    const obj2 = {
                      id: twoItem.id,
                      parent: twoItem.parent_id,
                      label: twoItem.area_name,
                      value: twoItem.area_code,
                    };
                    that.POS_MANAGE_MODULE.globalCompanyCity.push(obj2);
                    if (twoItem.treeList && twoItem.treeList.length > 0) {
                      twoItem.treeList.forEach(threeItem => {
                        // 区为树型结构中的三级节点，循环遍历后取出存入globalCompanyArea数组中
                        const obj3 = {
                          id: threeItem.id,
                          parent: threeItem.parent_id,
                          label: threeItem.area_name,
                          value: threeItem.area_code,
                        };
                        that.POS_MANAGE_MODULE.globalCompanyArea.push(obj3);
                      });
                    }
                  });
                }
              });
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口返回省/市/区
    // 2022.6.6 添加只查询允许使用的城市列表：masterType=1
    getProvinceCityAreaList(index = 0, id = 0, callback = null) {
      GetAreaList({ parent_id: id, sortType: 1, masterType: 1 })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              const tmpArr = [];
              res.rows.forEach(item => {
                tmpArr.push({
                  label: item.area_name,
                  value: item.id,
                });
              });
              if (index === 0) {
                this.POS_MANAGE_MODULE.globalCompanyProvince = tmpArr;
              }
              if (index === 1) {
                this.POS_MANAGE_MODULE.globalCompanyCity = tmpArr;
              }
              if (index === 2) {
                this.POS_MANAGE_MODULE.globalCompanyArea = tmpArr;
              }
              callback && callback(tmpArr[0].value);
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取行业列表
    getAllBusinessList(callback = null) {
      GetBusinessTreeListAsSecondaryNew()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                this.businessArr = [];
                for (let i = 0; i < res.rows.length; i++) {
                  this.businessArr.push({
                    itemName: i.toString(),
                    businessId: res.rows[i].bussiness_code,
                    businessName: res.rows[i].bussiness_name,
                    businessLabel: `${res.rows[i].bussiness_name}`,
                    subBusinessArr: [],
                  });
                  for (let j = 0; j < res.rows[i].treeList.length; j++) {
                    this.businessArr[i].subBusinessArr.push({
                      businessId: res.rows[i].treeList[j].bussiness_code,
                      businessName: res.rows[i].treeList[j].bussiness_name,
                      businessLabel: `${res.rows[i].treeList[j].bussiness_code} - ${res.rows[i].treeList[j].bussiness_name}`,
                      selected: false,
                    });
                  }
                }
                // 2022.7.19 向行业列表的数组中添加了一个时间戳的元素
                this.businessArr.push({ nowDate: Date.now() });
              }
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口查询自身是否有进件权限
    queryCustomerPermission(callback = null) {
      QueryCustomerPermission()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.isInBlackList = Boolean(res.data.isInBlacklist); // 0-不在，允许进件;1-在，不允许进件
              this.isInUserWhiteList = Boolean(res.data.type1Allowed); // 0-不在，不允许;1-在，允许
              this.isInAutoWhiteList = Boolean(res.data.type2Allowed); // 0-不在，不允许;1-在，允许
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 顶部进件记录按钮单击事件
    onTopToListCick() {
      this.$router.push({ path: '/h5posmanagemodule/poslist' });
    },
    // 下一步按钮点击事件/营业执照
    onShangHuCreateTypeClick() {
      if (!this.isInBlackList) {
        this.$router.push({ path: '/h5posmanagemodule/posedit?producttype=0' });
      }
    },
    // 小微商户
    onXiaoWeiCreateTypeClick() {
      if (this.isInUserWhiteList && !this.isInBlackList) {
        this.$router.push({ path: '/h5posmanagemodule/posedit?producttype=1' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.opacity-5 {
  opacity: 0.5;
}
</style>
